import React, { useState } from 'react';
import {useTranslation} from "react-i18next";

interface LazyMapImageProps {
  main: boolean; // This prop is to separate the main map and the map with route, not used since the vehicle option is removed.
  src: string;
  alt: string;
  className?: string;
}

const LazyMapImage: React.FC<LazyMapImageProps> = ({ main, src, alt, className }) => {
  const { t } = useTranslation();
  const [isLoaded, setIsLoaded] = useState(false);
  const [error, setError] = useState(false);

  return (
    <div className="relative w-full h-full">
      {!isLoaded && !error && (
        <div className={`absolute inset-0 flex items-center justify-center bg-gray-200 bg-opacity-70 ${main ? 'rounded-lg' : 'rounded-r-lg'}`}>
          <div className="flex items-center space-x-3">
            <svg
              className="w-5 h-5 animate-spin text-gray-600"
              viewBox="0 0 24 24"
              fill="none"
            >
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
              />
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              />
            </svg>
            <span className="text-gray-800 font-semibold">{t('BookingLoadingMap')}</span>
          </div>
        </div>
      )}
      <img
        src={src}
        alt={alt}
        className={className}
        loading="lazy"
        onLoad={() => setIsLoaded(true)}
        onError={() => setError(true)}
      />
    </div>
  );
};

export default LazyMapImage;